import React, { useState, useEffect, useCallback } from "react";
import { Tabs } from "antd";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import UsersList from "./UsersList";
import { getProfileTest } from "../../core/api/auth";
import LoginHistory from "./loginHistory";
const allTabs = [
  { key: "users", label: "Users List", path: "/access-control/users" },
  {
    key: "login-history",
    label: "Login History",
    path: "/access-control/login-history",
  },
  { key: "roles", label: "Roles", path: "/access-control/roles" },
  {
    key: "permissions",
    label: "Permissions",
    path: "/access-control/permissions",
  },
];

const AccessControlTab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const profile = useSelector((state) => state.profile);
  console.log("Profile from Access Control Tab:", profile);
  const [isAdmin, setIsAdmin] = useState(false);
  const authState = useSelector((state) => state.auth);
  const [activeKey, setActiveKey] = useState("users");

  const normalize = (str) => (str || "").replace(/\/+$/, "").toLowerCase();

  const getActiveKeyFromPath = useCallback(() => {
    const path = normalize(location.pathname);

    if (path.includes("/access-control/users")) return "users";
    if (path.includes("/access-control/login-history")) return "login-history";
    if (path.includes("/access-control/roles")) return "roles";
    if (path.includes("/access-control/permissions")) return "permissions";
    return "users";
  }, [location.pathname]);

  useEffect(() => {
    const active = getActiveKeyFromPath();
    setActiveKey(active);
  }, [location.pathname, getActiveKeyFromPath]);

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        if (authState && profile) {
          const userRole = profile.role?.toLowerCase();
          setIsAdmin(
            userRole === "admin" ||
              userRole === "super_admin" ||
              userRole === "management" ||
              userRole === "senior_accountant"
          );
        }
      } catch (error) {
        console.error("Error checking user role:", error);
      }
    };

    checkUserRole();
  }, [authState, profile]);

  const onChange = (key) => {
    navigate(`/access-control/${key}`);
    setActiveKey(key);
  };

  const renderTabContent = () => {
    switch (activeKey) {
      case "users":
        return <UsersList />;
      case "login-history":
        return <LoginHistory />;
      case "roles":
        return <div>Roles Management (Coming Soon)</div>;
      case "permissions":
        return <div>Permissions Management (Coming Soon)</div>;
      default:
        return <Navigate to="/access-control/users" replace />;
    }
  };

  if (!profile) return null;

  // Filter tabs based on user role
  const availableTabs = allTabs.filter((tab) => {
    // Admin, super_admin, management, and senior_accountant can access all tabs
    if ((tab.key === "roles" || tab.key === "permissions") && !isAdmin)
      return false;
    return true;
  });

  return (
    <div className="page-wrapper">
      <div className="settings-content">
        <div className="settings-dashboard-tabs">
          <Tabs
            activeKey={activeKey}
            onChange={onChange}
            type="card"
            size="small"
            tabBarStyle={{ marginBottom: "5px" }}
            items={availableTabs.map((tab) => ({
              key: tab.key,
              label: tab.label,
              closable: false,
            }))}
          />
          <div className="tab-content">{renderTabContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default AccessControlTab;
